
import { useState } from "react";
import styles from "../HealthChat.module.css";

const DOCTORS = [
  {
    id: "dr_aisha",
    name: "Dr. Aisha Patel",
    specialty: "OB-GYN",
    experience: "10+ years experience",
    rating: 4.9,
    reviews: 456,
    availability: "Available in 30 min",
    availColor: "#2e7d32",
    recommended: true,
    avatar: "👩‍⚕️",
    price: {
      video: 499,
      clinic: 800,
      chat: 99,
    },
  },
  {
    id: "dr_neha",
    name: "Dr. Neha Sharma",
    specialty: "OB-GYN",
    experience: "8 years experience",
    rating: 4.7,
    reviews: 312,
    availability: "Available at 12:00 PM",
    availColor: "#1565c0",
    recommended: false,
    avatar: "👩‍⚕️",
    price: {
      video: 499,
      clinic: 800,
      chat: 29,
    },
  },
  {
    id: "dr_sunita",
    name: "Dr. Sunita Mehra",
    specialty: "OB-GYN",
    experience: "15 years experience",
    rating: 4.9,
    reviews: 520,
    availability: "Available today",
    availColor: "#2e7d32",
    recommended: false,
    avatar: "👩‍⚕️",
    price: {
      video: 699,
      clinic: 900,
      chat: 19,
    },
  },
];

const FILTERS = ["Female doctor", "Hindi, English + 1", "Experience"];

function Stars({ rating }) {
  const full  = Math.floor(rating);
  const half  = rating % 1 >= 0.5;
  return (
    <span className={styles.doctorStars}>
      {"★".repeat(full)}
      {half ? "½" : ""}
      {"☆".repeat(5 - full - (half ? 1 : 0))}
    </span>
  );
}

export default function SelectDoctorScreen({ onSelect, onBack }) {
  const [activeFilters, setActiveFilters] = useState([]);

  function toggleFilter(f) {
    setActiveFilters((p) =>
      p.includes(f) ? p.filter((x) => x !== f) : [...p, f]
    );
  }

  return (
    <div className={styles.selectDoctorScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>← Back</button>
      <div className={styles.selectDoctorTitle}>Select a Doctor</div>

      {/* Filter chips */}
      <div className={styles.selectDoctorFilters}>
        {FILTERS.map((f) => (
          <button
            key={f}
            className={
              activeFilters.includes(f)
                ? styles.selectDoctorFilterActive
                : styles.selectDoctorFilter
            }
            onClick={() => toggleFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Doctor cards */}
      <div className={styles.selectDoctorList}>
        {DOCTORS.map((doc) => (
          <div key={doc.id} className={styles.selectDoctorCard}>
            {doc.recommended && (
              <div className={styles.selectDoctorBadge}>Recommended for you</div>
            )}
            <div className={styles.selectDoctorCardInner}>
              {/* Avatar */}
              <div className={styles.selectDoctorAvatar}>
                <span style={{ fontSize: 36 }}>{doc.avatar}</span>
              </div>

              {/* Info */}
              <div className={styles.selectDoctorInfo}>
                <div className={styles.selectDoctorName}>{doc.name}</div>
                <div className={styles.selectDoctorSpecialty}>{doc.specialty}</div>
                <div className={styles.selectDoctorExp}>{doc.experience}</div>
                <div className={styles.selectDoctorRatingRow}>
                  <Stars rating={doc.rating} />
                  <span className={styles.selectDoctorRatingNum}>{doc.rating}</span>
                  <span className={styles.selectDoctorReviews}>({doc.reviews})</span>
                </div>
                <div className={styles.selectDoctorAvail} style={{ color: doc.availColor }}>
                  ✔ {doc.availability}
                </div>
              </div>

              {/* Select btn */}
              <button
                className={styles.selectDoctorBtn}
                onClick={() => onSelect(doc)}
              >
                Select
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
